import { VStack, HStack, Heading, Text, Separator, Link } from '@chakra-ui/react'
import { FaChevronLeft } from 'react-icons/fa6'

export const RestoreHeader = () => (
  <VStack maxW="600px" m="auto" gap={0} alignItems="stretch">
    <HStack w="full" position="relative" py={3} px={4}>
      <Link
        href="/user/monthly_course_histories"
        textDecoration="none"
        color="label.secondary"
        position="absolute"
        left={4}
        top="50%"
        transform="translateY(-50%)"
      >
        <FaChevronLeft fontSize="2xl" />
      </Link>
      <Heading as="h1" size="sm" m="auto">
        月額コース再登録ページ
      </Heading>
    </HStack>
    <Separator />
    <Text fontSize="xs" p={4}>
      更新日より30日以内に当ページから再登録手続き完了で継続ボーナスを引き続き受け取ることができます。
      <br />
      <Text as="span" color="label.accent" fontWeight="semibold">
        登録内容、ご利用状況をご確認いただくか、大変お手数ですが新しいお支払い方法を選択の上再度登録を行ってください。
      </Text>
    </Text>
    <Separator />
  </VStack>
)
